import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import CustomInput from "components/CustomInput";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { isValidPassword } from "lib/form-helpers";
import { UPDATE_PASSWORD } from "@ugg/shared/api/graphql/queries";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";

const PasswordChange = (props) => {
  const { setSettingsNotification } = props;
  const [oldPassword, setOldPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [repeatPasswordError, setRepeatPasswordError] = useState("");

  const [updatePassword, { loading, data, error }] = useMutation(UPDATE_PASSWORD, {
    variables: {
      password: oldPassword,
      newPassword: newPassword,
    },
    context: { clientName: "auth-api" },
    onCompleted: (data) => {
      setOldPassword("");
      setNewPassword("");
      setRepeatPassword("");
      setSettingsNotification(true);
      window && window.scrollTo(0, 0);
    },
    onError: (error) => {
      console.error(error);
      setSettingsNotification(false);
    },
  });

  const verifyForm = () => {
    // Old Password
    if (oldPassword.length === 0) {
      return setOldPasswordError("Please enter your current password.");
    } else {
      setOldPasswordError("");
    }

    // New Password
    if (!isValidPassword(newPassword)) {
      return setNewPasswordError("Password must be at least 8 characters, with at least one letter and one number");
    } else {
      setNewPasswordError("");
    }

    // Repeat Password
    if (newPassword !== repeatPassword) {
      return setRepeatPasswordError("Passwords do not match.");
    } else {
      setRepeatPasswordError("");
    }

    // Attempt update settings
    return updatePassword();
  };

  return (
    <div className="settings-section change-password">
      <div className="section-content">
        <HeaderBullet className="mb-[24px]">Change Password</HeaderBullet>
        <div className="field-group">
          <div className="field-label">{"Old Password"}</div>
          <CustomInput
            value={oldPassword}
            error={oldPasswordError}
            onChange={(e) => setOldPassword(e.target.value)}
            tabIndex={6}
            type="password"
          />
        </div>
        <div className="field-group">
          <div className="field-label">{"New Password"}</div>
          <CustomInput
            value={newPassword}
            error={newPasswordError}
            onChange={(e) => setNewPassword(e.target.value)}
            tabIndex={7}
            type="password"
          />
        </div>
        <div className="field-group">
          <div className="field-label">{"Repeat New Password"}</div>
          <CustomInput
            value={repeatPassword}
            error={repeatPasswordError}
            onChange={(e) => setRepeatPassword(e.target.value)}
            tabIndex={8}
            type="password"
          />
        </div>
        <ButtonSuccess
          className="save-settings-btn btn-light-blue"
          label="Save Changes"
          isLoading={loading}
          onClick={verifyForm}
        />
      </div>
    </div>
  );
};

export default PasswordChange;
